import React from 'react';
import { LogOut, FileText } from 'lucide-react';
import logo from '../../assets/logo.png';

const Navbar = ({ onLogout }) => {

  const handlePublicDemo = () => {
    window.open('/publicdemo', '_blank');
  };

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-200">
      <div className="px-6 py-4 flex justify-between items-center">
        <div className="flex-1"></div>
        <div className="flex-1 text-center">
          <div className="flex items-center justify-center gap-3">
            <img src={logo} alt="Logo" className="h-8 w-auto" />
            <h1 className="text-xl font-bold text-gray-600">Demo Portal</h1>
          </div>
        </div>
        <div className="flex-1 flex justify-end items-center gap-2">
          <button
            onClick={handlePublicDemo}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors duration-200 shadow-sm border border-transparent"
            title="Try Public Demo"
          >
            <FileText size={18} />
            <span>Try Public Demo</span>
          </button>
          <button
            onClick={onLogout}
            className="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-full transition-colors duration-200"
            title="Logout"
          >
            <LogOut size={20} />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;